import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'widgets/Paper';
import CircularProgress from 'widgets/CircularProgress';
import PageTitle from 'components/PageTitle';
import './Sidebar.scss';

const style = {
  paperStyle: {
    boxShadow: 'rgba(0, 0, 0, 0.16) 0 3px 10px, rgba(0, 0, 0, 0.23) 0 3px 10px'
  },
  userActionButtonStyle: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  userActionButtonLabelStyle: {
    textTransform: 'none'
  }
};

function Sidebar({
  title,
  backLink,
  loading,
  children,
  className,
  ...otherProps
}) {
  return (
    <Paper className={`Sidebar ${className}`} cssStyles={{ root: style.paperStyle }} {...otherProps}>
      <PageTitle
        title={title}
        backLink={backLink}
        dividerStyle={{
          marginRight: 18,
          marginBottom: 10
        }}
      />
      {
        loading ?
          <center>
            <CircularProgress style={{ marginTop: 80 }} />
          </center> :
          <React.Fragment>
            {children}
          </React.Fragment>
      }
    </Paper>
  );
}

Sidebar.propTypes = {
  title: PropTypes.string,
  backLink: PropTypes.string,
  loading: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.array.isRequired,
};

Sidebar.defaultProps = {
  title: ' ',
  backLink: null,
  loading: false,
  className: ''
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx